import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import styles from "./CategoriesSettings.local.scss";
import SettingPageHeader from "../Common/PageHeader/SettingPageHeader";
import {
  setCurrentNavPage,
  initCategoriesSettings,
  initCapacityPlaningProduction,
  setLabelsForm,
  setCreatedCategories,
  setSuperCategorySettings,
  setAnalysisPlanSettings,
  setValuationSettings
} from "Actions";
import {
  fetchNonCategorizedTaskTypeCount,
  fetchSuperCategoriesSuggestions,
  fetchAnalysisPlanSuggestions,
  fetchValuationSuggestions,
  fetchCategoriesSettings,
  updateCategorySettings,
  updateSuperCategorySettings,
  updateAnalysisPlanSettings,
  updateValuationSettings,
  deleteCategorySettings,
  deleteSuperCategorySettings,
  deleteAnalysisPlanSettings,
  deleteValuationSettings,
  saveCategorySettings,
  saveSuperCategorySettings,
  saveAnalysisPlanSettings,
  saveValuationSettings
} from "Thunks";
import _ from "i18n";
import CategorySettingsSideBar from "./CategorySettingsSideBar";
import ItemCategory from "./ItemCategory";
import { onSuccess, onError } from "Utils";
import { goBack } from "react-router-redux";
import { DIALOG_TYPES } from "../../config";
import TTPDialog from "../Common/TTPDialog";
import { GarbageIcon, CercleAddIcon } from "../Common/Icons";
import NotFoundV2 from "../NotFound/NotFoundV2";

class CategorySettingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activated: null,
      labelsForm: {
        fr: "",
        en: "",
        nl: "",
        coefficient: 0.0,
        superCategory: null,
        analysisPlan: null,
        valuations: null,
        updatedBillable: null
      },
      originalLabels: [],
      labelsNeedsUpdate: false,
      deleteCategoryIsVisible: false,
      deleteCategoryIsForced: false,
      deleteSuperCategoryIsVisible: false,
      deleteSuperCategoryIsForced: false,
      deleteAnalysisPlanIsVisible: false,
      deleteAnalysisPlanIsForced: false,
      deleteValuationIsForced: false,
      updateCategoryIsForced: false,
      labelsUpdating: false,
      isAddingCategory: false,
      loading: false,
      idCategory: null,
      labelToUpdate: null,
      selectedSuperCategory: null,
      selectedAnalysisPlan: null,
      selectedValuation: null,
      filter: "categories",
      filterAdding: "categories",
      isBillable: false
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(setCurrentNavPage("CATEGORIES_SETTING"));

    dispatch(initCategoriesSettings());
    dispatch(fetchCategoriesSettings());
    dispatch(fetchSuperCategoriesSuggestions());
    dispatch(fetchValuationSuggestions());
    dispatch(fetchAnalysisPlanSuggestions());
    dispatch(fetchNonCategorizedTaskTypeCount());
  }

  handleToggleActivatedCategoryToUpdate = (
    categId,
    labels,
    selectedSuperCategory,
    selectedAnalysisPlan,
    selectedValuation,
    isBillable
  ) => {
    labels["superCategory"] = selectedSuperCategory;
    labels["analysisPlan"] = selectedAnalysisPlan;
    labels["valuations"] = selectedValuation;
    labels["updatedBillable"] = isBillable == null ? 0 : isBillable ? 1 : 0;
    const { dispatch } = this.props;
    const { activated } = this.state;
    if (!activated || activated !== categId) {
      this.setState({
        activated: categId,
        labelsForm: labels,
        originalLabels: labels,
        isAddingCategory: false,
        labelsNeedsUpdate: false,
        selectedSuperCategory: selectedSuperCategory,
        selectedAnalysisPlan: selectedAnalysisPlan,
        selectedValuation: selectedValuation
      });
      dispatch(
        setLabelsForm({
          fr: "",
          en: "",
          nl: "",
          coefficient: 0.0,
          superCategory: null,
          analysisPlan: null,
          valuations: null
        })
      );
    } else {
      this.setState({
        activated: null,
        labelsForm: {
          fr: "",
          en: "",
          nl: "",
          coefficient: 0.0,
          superCategory: null,
          analysisPlan: null,
          valuations: null,
          updatedBillable: null
        },
        originalLabels: [],
        isAddingCategory: false,
        labelsNeedsUpdate: false,
        selectedSuperCategory: null,
        selectedAnalysisPlan: null,
        selectedValuation: null
      });
      dispatch(
        setLabelsForm({
          fr: "",
          en: "",
          nl: "",
          coefficient: 0.0,
          superCategory: null,
          analysisPlan: null,
          valuations: null
        })
      );
    }
  };

  handleUpdatedBillableState = () => {
    const { labelsForm } = this.state;
    let newBillableState = labelsForm.updatedBillable === 1 ? 0 : 1;
    this.setState({
      labelsForm: {
        ...this.state.labelsForm,
        updatedBillable: newBillableState
      }
    });
    this.isLabelsNeedsUpdate();
  };

  isLabelsNeedsUpdate = () => {
    setTimeout(() => {
      if (
        JSON.stringify(this.state.labelsForm) !==
        JSON.stringify(this.state.originalLabels)
      ) {
        this.setState({ labelsNeedsUpdate: true });
      } else {
        this.setState({ labelsNeedsUpdate: false });
      }
    }, 100);
  };

  resetLabels = () => {
    this.setState({
      labelsForm: this.state.originalLabels,
      labelsNeedsUpdate: false
    });
  };

  onChangeLabelFormFr = event => {
    this.setState({
      labelsForm: { ...this.state.labelsForm, fr: event.target.value }
    });
    this.isLabelsNeedsUpdate();
  };

  onChangeLabelFormCoefficient = event => {
    this.setState({
      labelsForm: { ...this.state.labelsForm, coefficient: event.target.value }
    });
    this.isLabelsNeedsUpdate();
  };

  onChangeLabelFormEn = event => {
    this.setState({
      labelsForm: { ...this.state.labelsForm, en: event.target.value }
    });
    this.isLabelsNeedsUpdate();
  };

  onChangeLabelFormNl = event => {
    this.setState({
      labelsForm: { ...this.state.labelsForm, nl: event.target.value }
    });
    this.isLabelsNeedsUpdate();
  };

  onChangeSelectedSuperCategory = event => {
    this.setState({
      labelsForm: {
        ...this.state.labelsForm,
        superCategory: event ? event.value : null
      },
      selectedSuperCategory: event ? event.value : null
    });
    this.isLabelsNeedsUpdate();
  };

  onChangeSelectedAnalysisPlan = event => {
    this.setState({
      labelsForm: {
        ...this.state.labelsForm,
        analysisPlan: event ? event.value : null
      },
      selectedAnalysisPlan: event ? event.value : null
    });
    this.isLabelsNeedsUpdate();
  };

  onChangeSelectedValuation = event => {
    this.setState({
      labelsForm: {
        ...this.state.labelsForm,
        valuations: event ? event.value : null
      },
      selectedValuation: event ? event.value : null
    });

    this.isLabelsNeedsUpdate();
  };

  handleRedirectBack = () => {
    this.props.dispatch(goBack());
  };

  handleDisplayDeleteCategory = id => {
    this.setState({
      idCategory: id,
      deleteCategoryIsVisible: true
    });
  };

  handleDisplayDeleteSuperCategory = id => {
    this.setState({
      idCategory: id,
      deleteSuperCategoryIsVisible: true
    });
  };

  handleDisplayDeleteAnalysisPlan = id => {
    this.setState({
      idCategory: id,
      deleteAnalysisPlanIsVisible: true
    });
  };

  handleDisplayDeleteValuation = id => {
    this.setState({
      idCategory: id,
      deleteValuationIsVisible: true
    });
  };

  cancelDeleteCategory = () => {
    this.setState({
      idCategory: null,
      deleteCategoryIsVisible: false
    });
  };

  cancelDeleteSuperCategory = () => {
    this.setState({
      idCategory: null,
      deleteSuperCategoryIsVisible: false
    });
  };

  cancelDeleteAnalysisPlan = () => {
    this.setState({
      idCategory: null,
      deleteAnalysisPlanIsVisible: false
    });
  };

  cancelDeleteValuation = () => {
    this.setState({
      idCategory: null,
      deleteValuationIsVisible: false
    });
  };

  HandelDisplayDeleteForced = id => {
    this.setState({
      idCategory: id,
      deleteCategoryIsForced: true
    });
  };

  HandelDisplayDeleteSuperCategoryForced = id => {
    this.setState({
      idCategory: id,
      deleteSuperCategoryIsForced: true
    });
  };

  HandelDisplayDeleteAnalysisPlanForced = id => {
    this.setState({
      idCategory: id,
      deleteAnalysisPlanIsForced: true
    });
  };

  HandelDisplayForcedUpdateCategory = () => {
    this.setState({
      updateCategoryIsForced: true
    });
  };

  HandelDisplayDeleteValuationForced = id => {
    this.setState({
      idCategory: id,
      deleteValuationIsForced: true
    });
  };

  cancelDeleteForcedCategory = () => {
    this.setState({
      idCategory: null,
      deleteCategoryIsForced: false
    });
  };

  cancelDeleteForcedSuperCategory = () => {
    this.setState({
      idCategory: null,
      deleteSuperCategoryIsForced: false
    });
  };

  cancelDeleteForcedAnalysisPlan = () => {
    this.setState({
      idCategory: null,
      deleteAnalysisPlanIsForced: false
    });
  };

  cancelDeleteForcedValuation = () => {
    this.setState({
      idCategory: null,
      deleteValuationIsForced: false
    });
  };

  cancelUpdateForcedCategory = () => {
    this.setState({
      idCategory: null,
      updateCategoryIsForced: false
    });
  };

  handleUpdateCategory = () => {
    const { activated, labelsForm } = this.state;
    const { dispatch, categories } = this.props;

    let updatedCateg = categories;
    this.setState({
      labelsUpdating: true
    });
    let isForse = false;
    if (this.state.updateCategoryIsForced) {
      isForse = true;
    }
    dispatch(updateCategorySettings(activated, labelsForm, isForse)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("categoryUpdated")
        });

        updatedCateg.forEach((item, i) => {
          if (item.id === activated) {
            updatedCateg[i].isBillable = labelsForm.updatedBillable;
            updatedCateg[i].label = labelsForm;
            updatedCateg[i].superCategory = labelsForm.superCategory;
            updatedCateg[i].analysisPlan = labelsForm.analysisPlan;
            updatedCateg[i].valuations = labelsForm.valuations;
          }
        });
        this.setState({
          activated: null,
          labelsForm: {
            fr: "",
            en: "",
            nl: "",
            coefficient: 0.0,
            superCategory: null,
            analysisPlan: null,
            valuations: null,
            updatedBillable: null
          },
          originalLabels: [],
          isAddingCategory: false,
          labelsUpdating: false,
          labelsNeedsUpdate: false
        });
        setTimeout(() => {
          dispatch(setCreatedCategories(updatedCateg));
        }, 400);
        dispatch(initCapacityPlaningProduction());
        this.cancelUpdateForcedCategory();
      },
      err => {
        if (err.response.data.errors[0].code === 170073) {
          if (!this.state.updateCategoryIsForced) {
            this.HandelDisplayForcedUpdateCategory();
          } else {
            this.cancelUpdateForcedCategory();
          }
        } else {
          onError(err.response.data.errors[0].message);
        }
        this.setState({ labelsUpdating: false });
      }
    );
  };

  handleUpdateSuperCategory = () => {
    const { activated, labelsForm } = this.state;
    const { dispatch, superCategories, categories } = this.props;

    let updatedSuperCateg = superCategories.items;
    let updatedCateg = categories;

    this.setState({
      labelsUpdating: true
    });

    dispatch(updateSuperCategorySettings(activated, labelsForm)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("categoryUpdated")
        });

        updatedSuperCateg.forEach((item, i) => {
          if (item.id === activated) {
            updatedSuperCateg[i].label = labelsForm;
          }
        });
        updatedCateg.forEach((item, i) => {
          if (item.superCategory === activated) {
            updatedCateg[i].superCategory = activated;
          }
        });
        dispatch(setSuperCategorySettings(updatedSuperCateg));
        dispatch(setCreatedCategories(updatedCateg));
        this.setState({
          activated: null,
          labelsForm: {
            fr: "",
            en: "",
            nl: "",
            coefficient: 0.0,
            superCategory: null,
            analysisPlan: null,
            valuations: null,
            updatedBillable: null
          },
          originalLabels: [],
          isAddingCategory: false,
          labelsUpdating: false,
          labelsNeedsUpdate: false,
          selectedSuperCategory: null,
          selectedAnalysisPlan: null,
          selectedValuation: null
        });
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        onError(err.response.data.errors[0].message);
        this.setState({
          labelsUpdating: false
        });
      }
    );
  };

  handleUpdateAnalysisPlan = () => {
    const { activated, labelsForm } = this.state;
    const { dispatch, analysisPlan, categories } = this.props;

    let updatedAnalysisPlan = analysisPlan.items;
    let updatedCateg = categories;

    this.setState({
      labelsUpdating: true
    });

    dispatch(updateAnalysisPlanSettings(activated, labelsForm)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("categoryUpdated")
        });

        updatedAnalysisPlan.forEach((item, i) => {
          if (item.id === activated) {
            updatedAnalysisPlan[i].label = labelsForm;
          }
        });
        updatedCateg.forEach((item, i) => {
          if (item.superCategory === activated) {
            updatedCateg[i].analysisPlan = activated;
          }
        });
        dispatch(setAnalysisPlanSettings(updatedAnalysisPlan));
        dispatch(setCreatedCategories(updatedCateg));
        this.setState({
          activated: null,
          labelsForm: {
            fr: "",
            en: "",
            nl: "",
            coefficient: 0.0,
            superCategory: null,
            analysisPlan: null,
            valuations: null
          },
          originalLabels: [],
          isAddingCategory: false,
          labelsUpdating: false,
          labelsNeedsUpdate: false,
          selectedSuperCategory: null,
          selectedAnalysisPlan: null,
          selectedValuation: null
        });
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        onError(err.response.data.errors[0].message);
        this.setState({
          labelsUpdating: false
        });
      }
    );
  };

  handleUpdateValuation = () => {
    const { activated, labelsForm } = this.state;
    const { dispatch, valuations, categories } = this.props;

    let updatedValuation = valuations.items;
    let updatedCateg = categories;

    this.setState({
      labelsUpdating: true
    });

    dispatch(updateValuationSettings(activated, labelsForm)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("ValuationUpdated")
        });

        updatedValuation.forEach((item, i) => {
          if (item.id === activated) {
            updatedValuation[i].label = labelsForm;
          }
        });
        updatedCateg.forEach((item, i) => {
          if (item.superCategory === activated) {
            updatedCateg[i].valuations = activated;
          }
        });
        dispatch(setValuationSettings(updatedValuation));
        dispatch(setCreatedCategories(updatedCateg));
        this.setState({
          activated: null,
          labelsForm: {
            fr: "",
            en: "",
            nl: "",
            coefficient: 0.0,
            superCategory: null,
            valuations: null
          },
          originalLabels: [],
          isAddingCategory: false,
          labelsUpdating: false,
          labelsNeedsUpdate: false,
          selectedSuperCategory: null,
          selectedValuation: null
        });
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        onError(err.response.data.errors[0].message);
        this.setState({
          labelsUpdating: false
        });
      }
    );
  };

  handleDeleteCategory = () => {
    const { categories, dispatch } = this.props;
    let updatedCateg = categories;
    let isForse = false;
    let idCateg = this.state.idCategory;
    this.setState({ loading: true });
    if (this.state.deleteCategoryIsForced) {
      isForse = true;
    }
    dispatch(deleteCategorySettings(this.state.idCategory, isForse)).then(
      res => {
        this.setState({ loading: false });
        onSuccess(res, {
          title: _("removeSuccess"),
          body: _("categoryDeleted")
        });
        this.props.dispatch(
          setCreatedCategories(
            updatedCateg.filter(({ id }) => id !== this.state.idCategory)
          )
        );
        this.cancelDeleteCategory();
        this.cancelDeleteForcedCategory();
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        this.cancelDeleteCategory();
        this.setState({ loading: false });
        if (!this.state.deleteCategoryIsForced) {
          this.HandelDisplayDeleteForced(idCateg);
        } else {
          this.cancelDeleteForcedCategory();
        }
      }
    );
  };

  handleDeleteSuperCategory = () => {
    const { superCategories, categories, dispatch } = this.props;
    const { idCategory } = this.state;
    let updatedSuperCateg = superCategories.items;
    let updatedCateg = categories;
    let isForse = false;
    let idCateg = this.state.idCategory;
    this.setState({ loading: true });
    if (this.state.deleteSuperCategoryIsForced) {
      isForse = true;
    }
    dispatch(deleteSuperCategorySettings(idCategory, isForse)).then(
      res => {
        this.setState({ loading: false });
        onSuccess(res, {
          title: _("removeSuccess"),
          body: _("categoryDeleted")
        });

        let newSuperCateg = updatedSuperCateg.filter(
          ({ id }) => id !== idCategory
        );
        dispatch(setSuperCategorySettings([]));
        dispatch(setSuperCategorySettings(newSuperCateg));
        updatedCateg.forEach((item, i) => {
          if (item.superCategory === idCategory) {
            updatedCateg[i].superCategory = null;
          }
        });
        dispatch(setCreatedCategories(updatedCateg));
        this.cancelDeleteSuperCategory();
        this.cancelDeleteForcedSuperCategory();
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        this.cancelDeleteCategory();
        this.setState({ loading: false });
        if (!this.state.deleteSuperCategoryIsForced) {
          this.HandelDisplayDeleteSuperCategoryForced(idCateg);
        } else {
          this.cancelDeleteForcedSuperCategory();
        }
      }
    );
  };

  handleDeleteAnalysisPlan = () => {
    const { analysisPlan, categories, dispatch } = this.props;
    const { idCategory } = this.state;
    let updatedAnalysisPlan = analysisPlan.items;
    let updatedCateg = categories;
    let isForse = false;
    let idCateg = this.state.idCategory;
    this.setState({ loading: true });
    if (this.state.deleteAnalysisPlanIsForced) {
      isForse = true;
    }
    dispatch(deleteAnalysisPlanSettings(idCategory, isForse)).then(
      res => {
        this.setState({ loading: false });
        onSuccess(res, {
          title: _("removeSuccess"),
          body: _("categoryDeleted")
        });

        let newAnalysisPlan = updatedAnalysisPlan.filter(
          ({ id }) => id !== idCategory
        );
        dispatch(setAnalysisPlanSettings([]));
        dispatch(setAnalysisPlanSettings(newAnalysisPlan));
        updatedCateg.forEach((item, i) => {
          if (item.analysisPlan === idCategory) {
            updatedCateg[i].analysisPlan = null;
          }
        });
        dispatch(setCreatedCategories(updatedCateg));
        this.cancelDeleteAnalysisPlan();
        this.cancelDeleteForcedAnalysisPlan();
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        this.cancelDeleteCategory();
        this.setState({ loading: false });
        if (!this.state.deleteAnalysisPlanIsForced) {
          this.HandelDisplayDeleteAnalysisPlanForced(idCateg);
        } else {
          this.cancelDeleteForcedAnalysisPlan();
        }
      }
    );
  };

  handleDeleteValuation = () => {
    const { valuations, categories, dispatch } = this.props;
    const { idCategory } = this.state;
    let updatedValuation = valuations.items;
    let updatedCateg = categories;
    let isForse = false;
    let idCateg = this.state.idCategory;
    this.setState({ loading: true });
    if (this.state.deleteValuationIsForced) {
      isForse = true;
    }
    dispatch(deleteValuationSettings(idCategory, isForse)).then(
      res => {
        this.setState({ loading: false });
        onSuccess(res, {
          title: _("removeSuccess"),
          body: _("ValuationDeleted")
        });

        let newValuation = updatedValuation.filter(
          ({ id }) => id !== idCategory
        );
        dispatch(setValuationSettings([]));
        dispatch(setValuationSettings(newValuation));
        updatedCateg.forEach((item, i) => {
          if (item.valuations === idCategory) {
            updatedCateg[i].valuations = null;
          }
        });
        dispatch(setCreatedCategories(updatedCateg));
        this.cancelDeleteValuation();
        this.cancelDeleteForcedValuation();
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        this.cancelDeleteCategory();
        this.setState({ loading: false });
        if (!this.state.deleteValuationIsForced) {
          this.HandelDisplayDeleteValuationForced(idCateg);
        } else {
          this.cancelDeleteForcedValuation();
        }
      }
    );
  };

  renderCreatedCategories = () => {
    const {
      lng,
      categories,
      superCategories,
      analysisPlan,
      valuations
    } = this.props;
    const superCategoriesOptions =
      superCategories.items &&
      superCategories.items.map(item => {
        return { label: item.label[lng], value: item.id };
      });
    const analysisPlanOptions =
      analysisPlan.items &&
      analysisPlan.items.map(item => {
        return { label: item.label[lng], value: item.id };
      });
    const valuationOptions =
      valuations.items &&
      valuations.items.map(item => {
        return { label: item.label[lng], value: item.id };
      });
    return (
      <div className={classnames("row")}>
        {categories.map((item, i) => {
          return (
            <div
              key={`category-${i}`}
              className={classnames(
                "columns medium-4 small-6",
                styles.item_div
              )}
            >
              <ItemCategory
                isBillable={this.state.labelsForm.updatedBillable}
                handleUpdateBillableState={this.handleUpdatedBillableState}
                active={this.state.activated === item.id}
                item={item}
                lng={lng}
                superCategoriesOptions={superCategoriesOptions}
                analysisPlanOptions={analysisPlanOptions}
                valuationOptions={valuationOptions}
                handleToggleActivatedCategoryToUpdate={
                  this.handleToggleActivatedCategoryToUpdate
                }
                selectedSuperCategory={this.state.selectedSuperCategory}
                selectedAnalysisPlan={this.state.selectedAnalysisPlan}
                selectedValuation={this.state.selectedValuation}
                labelsForm={this.state.labelsForm}
                onChangeLabelFormFr={this.onChangeLabelFormFr}
                onChangeLabelFormEn={this.onChangeLabelFormEn}
                onChangeLabelFormNl={this.onChangeLabelFormNl}
                onChangeSelectedSuperCategory={
                  this.onChangeSelectedSuperCategory
                }
                onChangeSelectedAnalysisPlan={this.onChangeSelectedAnalysisPlan}
                onChangeSelectedValuation={this.onChangeSelectedValuation}
                associatedSuperCategory={
                  item.superCategory && superCategoriesOptions
                    ? superCategoriesOptions.filter(
                        option => option.value === item.superCategory
                      )
                    : []
                }
                associatedAnalysisPlan={
                  item.analysisPlan && analysisPlanOptions
                    ? analysisPlanOptions.filter(
                        option => option.value === item.analysisPlan
                      )
                    : []
                }
                associatedValuation={
                  item.valuations && valuationOptions
                    ? valuationOptions.filter(
                        option => option.value === item.valuations
                      )
                    : []
                }
                filter={this.state.filter}
                labelsNeedsUpdate={this.state.labelsNeedsUpdate}
                resetLabels={this.resetLabels}
                handleUpdateCategory={this.handleUpdateCategory}
                saving={this.state.labelsUpdating}
                deleting={this.props.deleting}
                handleDisplayDeleteCategory={this.handleDisplayDeleteCategory}
                loading={this.state.loading}
                associated={true}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderCreatedSuperCategories = () => {
    const { lng, superCategories } = this.props;

    return (
      <div className={classnames("row")}>
        {superCategories.items.map((item, i) => {
          return (
            <div
              className={classnames(
                "columns medium-4 small-6",
                styles.item_div
              )}
            >
              <ItemCategory
                active={this.state.activated === item.id}
                item={item}
                lng={lng}
                handleToggleActivatedCategoryToUpdate={
                  this.handleToggleActivatedCategoryToUpdate
                }
                filter={this.state.filter}
                selectedSuperCategory={null}
                selectedAnalysisPlan={null}
                selectedValuation={null}
                labelsForm={this.state.labelsForm}
                onChangeLabelFormFr={this.onChangeLabelFormFr}
                onChangeLabelFormEn={this.onChangeLabelFormEn}
                onChangeLabelFormNl={this.onChangeLabelFormNl}
                onChangeSelectedSuperCategory={null}
                onChangeselectedAnalysisPlan={null}
                onChangeSelectedValuation={null}
                associatedSuperCategory={null}
                associatedAnalysisPlan={null}
                associatedValuation={null}
                labelsNeedsUpdate={this.state.labelsNeedsUpdate}
                resetLabels={this.resetLabels}
                handleUpdateCategory={this.handleUpdateSuperCategory}
                saving={this.state.labelsUpdating}
                deleting={this.props.deleting}
                handleDisplayDeleteCategory={
                  this.handleDisplayDeleteSuperCategory
                }
                loading={this.state.loading}
                associated={false}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderCreatedClassification = () => {
    const { lng, valuations } = this.props;

    return (
      <div className={classnames("row")}>
        {valuations.items.map((item, i) => {
          return (
            <div
              className={classnames(
                "columns medium-4 small-6",
                styles.item_div
              )}
            >
              <ItemCategory
                active={this.state.activated === item.id}
                item={item}
                lng={lng}
                handleToggleActivatedCategoryToUpdate={
                  this.handleToggleActivatedCategoryToUpdate
                }
                filter={this.state.filter}
                selectedSuperCategory={null}
                selectedAnalysisPlan={null}
                selectedValuation={null}
                labelsForm={this.state.labelsForm}
                onChangeLabelFormFr={this.onChangeLabelFormFr}
                onChangeLabelFormEn={this.onChangeLabelFormEn}
                onChangeLabelFormNl={this.onChangeLabelFormNl}
                onChangeLabelFormCoefficient={this.onChangeLabelFormCoefficient}
                onChangeSelectedSuperCategory={null}
                onChangeselectedAnalysisPlan={null}
                onChangeSelectedValuation={null}
                associatedSuperCategory={null}
                associatedAnalysisPlan={null}
                associatedValuation={null}
                labelsNeedsUpdate={this.state.labelsNeedsUpdate}
                resetLabels={this.resetLabels}
                handleUpdateCategory={this.handleUpdateValuation}
                saving={this.state.labelsUpdating}
                deleting={this.props.deleting}
                handleDisplayDeleteCategory={this.handleDisplayDeleteValuation}
                loading={this.state.loading}
                associated={false}
                isClassification={true}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderCreatedAnalysesPlan = () => {
    const { lng, analysisPlan } = this.props;

    return (
      <div className={classnames("row")}>
        {analysisPlan.items.map((item, i) => {
          return (
            <div
              className={classnames(
                "columns medium-4 small-6",
                styles.item_div
              )}
            >
              <ItemCategory
                active={this.state.activated === item.id}
                item={item}
                lng={lng}
                handleToggleActivatedCategoryToUpdate={
                  this.handleToggleActivatedCategoryToUpdate
                }
                filter={this.state.filter}
                selectedSuperCategory={null}
                selectedAnalysisPlan={null}
                selectedValuation={null}
                labelsForm={this.state.labelsForm}
                onChangeLabelFormFr={this.onChangeLabelFormFr}
                onChangeLabelFormEn={this.onChangeLabelFormEn}
                onChangeLabelFormNl={this.onChangeLabelFormNl}
                onChangeSelectedSuperCategory={null}
                onChangeselectedAnalysisPlan={null}
                onChangeSelectedValuation={null}
                associatedSuperCategory={null}
                associatedAnalysisPlan={null}
                associatedValuation={null}
                labelsNeedsUpdate={this.state.labelsNeedsUpdate}
                resetLabels={this.resetLabels}
                handleUpdateCategory={this.handleUpdateAnalysisPlan}
                saving={this.state.labelsUpdating}
                deleting={this.props.deleting}
                handleDisplayDeleteCategory={
                  this.handleDisplayDeleteAnalysisPlan
                }
                loading={this.state.loading}
                associated={false}
              />
            </div>
          );
        })}
      </div>
    );
  };

  onClickNewCategory = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.remove("hide");
    //  document.getElementById("mainMenu").style.zIndex = 6;
    document.body.style.overflow = "hidden";

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.setState({
      isBillable: false,
      activated: null,
      labelsForm: {
        fr: "",
        en: "",
        nl: "",
        coefficient: 0.0,
        superCategory: null,
        analysisPlan: null,
        valuations: null
      },
      originalLabels: {
        fr: "",
        en: "",
        nl: "",
        coefficient: 0.0,
        superCategory: null,
        analysisPlan: null,
        valuations: null
      },
      isAddingCategory: true,
      selectedSuperCategory: null,
      selectedAnalysisPlan: null,
      selectedValuation: null,
      labelsNeedsUpdate: 0
    });
  };

  onCancelNewCategory = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    //  document.getElementById("mainMenu").style.zIndex = 4;
    document.body.style.removeProperty("overflow");

    this.setState({
      isAddingCategory: false,
      isBillable: false
    });
  };

  handleSaveNewCategory = () => {
    const { labelsForm, isBillable } = this.state;
    const { dispatch, categories } = this.props;

    let updatedCateg = categories;

    dispatch(saveCategorySettings(labelsForm, isBillable)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("categoryAdded")
        });
        updatedCateg.push({
          id: res.value.data.data["id"],
          label: labelsForm,
          superCategory: labelsForm.superCategory,
          analysisPlan: labelsForm.analysisPlan,
          valuations: labelsForm.valuations,
          isBillable: isBillable
        });
        dispatch(setCreatedCategories(updatedCateg));
        this.onCancelNewCategory();
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };

  handleSaveNewSuperCategory = () => {
    const { labelsForm } = this.state;
    const { dispatch, superCategories, categories } = this.props;

    let updatedSuperCateg = superCategories.items;

    dispatch(saveSuperCategorySettings(labelsForm)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("categoryAdded")
        });
        updatedSuperCateg.push({
          id: res.value.data.data["id"],
          label: labelsForm
        });
        dispatch(setSuperCategorySettings(updatedSuperCateg));
        dispatch(setCreatedCategories(categories));
        this.onCancelNewCategory();
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };

  handleSaveNewAnalysisPlan = () => {
    const { labelsForm } = this.state;
    const { dispatch, analysisPlan, categories } = this.props;

    let updatedAnalysisPlan = analysisPlan.items;

    dispatch(saveAnalysisPlanSettings(labelsForm)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("categoryAdded")
        });
        updatedAnalysisPlan.push({
          id: res.value.data.data["id"],
          label: labelsForm
        });
        dispatch(setAnalysisPlanSettings(updatedAnalysisPlan));
        dispatch(setCreatedCategories(categories));
        this.onCancelNewCategory();
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };
  handleSaveNewValuation = () => {
    const { labelsForm } = this.state;
    const { dispatch, valuations, categories } = this.props;

    let updatedValuation = valuations.items;

    dispatch(saveValuationSettings(labelsForm)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("ValuationAdded")
        });
        updatedValuation.push({
          id: res.value.data.data["id"],
          label: labelsForm
        });
        dispatch(setValuationSettings(updatedValuation));
        dispatch(setCreatedCategories(categories));
        this.onCancelNewCategory();
        dispatch(initCapacityPlaningProduction());
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };

  renderAddBubble = () => {
    const { isAddingCategory } = this.state;
    return (
      <div className={styles.bubbles}>
        <div
          className={isAddingCategory ? styles.opened : ""}
          onClick={() => this.onClickNewCategory()}
        >
          <CercleAddIcon fill={isAddingCategory ? "#fff" : "#29394D"} />
          <span style={{ paddingLeft: "2.5rem" }}>{_("add")}</span>
        </div>
      </div>
    );
  };

  componentWillUnmount() {
    this.onCancelNewCategory();
  }

  onChangeFilter = filter => {
    this.setState({
      filter: filter,
      filterAdding: filter,
      activated: null
    });
  };

  onChangeFilterAdding = filter => {
    this.setState({
      filterAdding: filter,
      activated: null,
      labelsForm: {
        fr: "",
        en: "",
        nl: "",
        coefficient: 0.0,
        superCategory: null,
        analysisPlan: null,
        valuations: null
      }
    });
  };

  handleChangeBillableState = () => {
    const { isBillable } = this.state;

    this.setState({ isBillable: !isBillable });
  };

  render() {
    const {
      fetching,
      fetched,
      saving,
      superCategories,
      analysisPlan,
      categories,
      valuations,
      lng
    } = this.props;
    const {
      isAddingCategory,
      labelsForm,
      coefficient,
      isBillable
    } = this.state;

    const superCategoriesOptions =
      superCategories.items &&
      superCategories.items.map(item => {
        return { label: item.label[lng], value: item.id };
      });
    const analysisPlanOptions =
      analysisPlan.items &&
      analysisPlan.items.map(item => {
        return { label: item.label[lng], value: item.id };
      });
    const valuationOptions =
      valuations.items &&
      valuations.items.map(item => {
        return { label: item.label[lng], value: item.id };
      });
    return (
      <div className={classnames(styles.settings_categories, "page-content")}>
        <SettingPageHeader
          title={_("manageCategories")}
          onBack={() => this.handleRedirectBack()}
        />
        <div className={styles.categories_block}>
          <div className={styles.title_block}>
            <h2 className={styles.title}>{_("categoriesList")}</h2>
            <h3 className={styles.subtitle}>{_("addCategories")}</h3>
          </div>
          <div className={styles.tabs_block}>
            <div
              className={classnames(
                styles.tab,
                this.state.filter === "categories" ? styles.active : ""
              )}
              onClick={() => this.onChangeFilter("categories")}
            >
              {_("Categories")}
            </div>
            <div
              className={classnames(
                styles.tab,
                this.state.filter === "superCategories" ? styles.active : ""
              )}
              onClick={() => this.onChangeFilter("superCategories")}
            >
              {_("SuperCategories")}
            </div>
            <div
              className={classnames(
                styles.tab,
                this.state.filter === "analysisPlan" ? styles.active : ""
              )}
              onClick={() => this.onChangeFilter("analysisPlan")}
            >
              {_("AnalysesPlan")}
            </div>
            <div
              className={classnames(
                styles.tab,
                this.state.filter === "valuation" ? styles.active : ""
              )}
              onClick={() => this.onChangeFilter("valuation")}
            >
              {_("classification")}
            </div>
          </div>
          {fetching && (
            <div className={styles.ripple_loading_adapted}>
              <img src={"/img/Ripple-1s-150px.svg"} alt="" />
            </div>
          )}

          {fetched && <div className={styles.divider} />}
          {this.state.filter === "categories" ? (
            fetched && superCategories.fetched && analysisPlan.fetched ? (
              categories.length > 0 ? (
                this.renderCreatedCategories()
              ) : (
                <NotFoundV2 />
              )
            ) : (
              ""
            )
          ) : this.state.filter === "superCategories" ? (
            superCategories.fetched ? (
              superCategories.items.length > 0 ? (
                this.renderCreatedSuperCategories()
              ) : (
                <NotFoundV2 />
              )
            ) : (
              ""
            )
          ) : this.state.filter === "valuation" ? (
            valuations.fetched ? (
              valuations.items.length > 0 ? (
                this.renderCreatedClassification()
              ) : (
                <NotFoundV2 />
              )
            ) : (
              ""
            )
          ) : analysisPlan.fetched ? (
            analysisPlan.items.length > 0 ? (
              this.renderCreatedAnalysesPlan()
            ) : (
              <NotFoundV2 />
            )
          ) : (
            ""
          )}
        </div>
        {this.renderAddBubble()}
        {fetched &&
          superCategories.fetched &&
          analysisPlan.fetched &&
          valuations.fetched &&
          (this.state.filterAdding === "categories" ? (
            <CategorySettingsSideBar
              saving={saving}
              isAddingCategory={isAddingCategory}
              labelsForm={labelsForm}
              isBillable={isBillable}
              handleChangeBillableState={this.handleChangeBillableState}
              onCancelNewCategory={this.onCancelNewCategory}
              onChangeLabelFormFr={this.onChangeLabelFormFr}
              onChangeLabelFormEn={this.onChangeLabelFormEn}
              onChangeLabelFormNl={this.onChangeLabelFormNl}
              handleSaveNewCategory={this.handleSaveNewCategory}
              selectedSuperCategory={this.state.selectedSuperCategory}
              selectedAnalysisPlan={this.state.selectedAnalysisPlan}
              selectedValuation={this.state.selectedValuation}
              superCategoriesOptions={superCategoriesOptions}
              analysisPlanOptions={analysisPlanOptions}
              valuationOptions={valuationOptions}
              onChangeSelectedSuperCategory={this.onChangeSelectedSuperCategory}
              onChangeSelectedAnalysisPlan={this.onChangeSelectedAnalysisPlan}
              onChangeSelectedValuation={this.onChangeSelectedValuation}
              associated={true}
              onChangeFilterAdding={this.onChangeFilterAdding}
              filterAdding={this.state.filterAdding}
            />
          ) : this.state.filterAdding === "superCategories" ? (
            <CategorySettingsSideBar
              saving={saving}
              isAddingCategory={isAddingCategory}
              labelsForm={labelsForm}
              onCancelNewCategory={this.onCancelNewCategory}
              onChangeLabelFormFr={this.onChangeLabelFormFr}
              onChangeLabelFormEn={this.onChangeLabelFormEn}
              onChangeLabelFormNl={this.onChangeLabelFormNl}
              handleSaveNewCategory={this.handleSaveNewSuperCategory}
              selectedSuperCategory={this.state.selectedSuperCategory}
              selectedAnalysisPlan={this.state.selectedAnalysisPlan}
              selectedValuation={this.state.selectedValuation}
              superCategoriesOptions={superCategoriesOptions}
              analysisPlanOptions={analysisPlanOptions}
              valuationOptions={valuationOptions}
              onChangeSelectedSuperCategory={this.onChangeSelectedSuperCategory}
              onChangeSelectedAnalysisPlan={this.onChangeSelectedAnalysisPlan}
              onChangeSelectedValuation={this.onChangeSelectedValuation}
              associated={false}
              onChangeFilterAdding={this.onChangeFilterAdding}
              filterAdding={this.state.filterAdding}
            />
          ) : this.state.filterAdding === "valuation" ? (
            <CategorySettingsSideBar
              saving={saving}
              isAddingCategory={isAddingCategory}
              labelsForm={labelsForm}
              coefficient={coefficient}
              onCancelNewCategory={this.onCancelNewCategory}
              onChangeLabelFormFr={this.onChangeLabelFormFr}
              onChangeLabelFormEn={this.onChangeLabelFormEn}
              onChangeLabelFormNl={this.onChangeLabelFormNl}
              onChangeLabelFormCoefficient={this.onChangeLabelFormCoefficient}
              handleSaveNewCategory={this.handleSaveNewValuation}
              selectedSuperCategory={this.state.selectedSuperCategory}
              selectedAnalysisPlan={this.state.selectedAnalysisPlan}
              selectedValuation={this.state.selectedValuation}
              superCategoriesOptions={superCategoriesOptions}
              valuationOptions={valuationOptions}
              onChangeSelectedSuperCategory={this.onChangeSelectedSuperCategory}
              onChangeSelectedAnalysisPlan={this.onChangeSelectedAnalysisPlan}
              onChangeSelectedValuation={this.onChangeSelectedValuation}
              associated={false}
              onChangeFilterAdding={this.onChangeFilterAdding}
              filterAdding={this.state.filterAdding}
            />
          ) : (
            <CategorySettingsSideBar
              saving={saving}
              isAddingCategory={isAddingCategory}
              labelsForm={labelsForm}
              onCancelNewCategory={this.onCancelNewCategory}
              onChangeLabelFormFr={this.onChangeLabelFormFr}
              onChangeLabelFormEn={this.onChangeLabelFormEn}
              onChangeLabelFormNl={this.onChangeLabelFormNl}
              handleSaveNewCategory={this.handleSaveNewAnalysisPlan}
              selectedSuperCategory={this.state.selectedAnalysisPlan}
              superCategoriesOptions={superCategoriesOptions}
              analysisPlanOptions={analysisPlanOptions}
              valuationOptions={valuationOptions}
              onChangeSelectedSuperCategory={null}
              associated={false}
              onChangeFilterAdding={this.onChangeFilterAdding}
              filterAdding={this.state.filterAdding}
            />
          ))}
        <TTPDialog
          showDialog={this.state.deleteCategoryIsVisible}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteCategory,
            abortAction: this.cancelDeleteCategory,
            message: _("confirmationDeleteCategoryMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteCategoryTitle"
          }}
        />
        <TTPDialog
          showDialog={this.state.deleteCategoryIsForced}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteCategory,
            abortAction: this.cancelDeleteForcedCategory,
            message: _("confirmationForcedDeleteCategoryMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationForceDeleteCategoryTitle"
          }}
        />
        <TTPDialog
          showDialog={this.state.deleteSuperCategoryIsVisible}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteSuperCategory,
            abortAction: this.cancelDeleteSuperCategory,
            message: _("confirmationDeleteSuperCategoryMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteCategoryTitle"
          }}
        />
        <TTPDialog
          showDialog={this.state.deleteSuperCategoryIsForced}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteSuperCategory,
            abortAction: this.cancelDeleteForcedSuperCategory,
            message: _("confirmationForcedDeleteCategoryMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationForceDeleteCategoryTitle"
          }}
        />
        <TTPDialog
          showDialog={this.state.deleteAnalysisPlanIsVisible}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteAnalysisPlan,
            abortAction: this.cancelDeleteAnalysisPlan,
            message: _("confirmationDeleteAnalysisPlanMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteCategoryTitle"
          }}
        />
        <TTPDialog
          showDialog={this.state.deleteAnalysisPlanIsForced}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteAnalysisPlan,
            abortAction: this.cancelDeleteForcedAnalysisPlan,
            message: _("confirmationForcedDeleteCategoryMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationForceDeleteCategoryTitle"
          }}
        />
        <TTPDialog
          showDialog={this.state.deleteValuationIsVisible}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteValuation,
            abortAction: this.cancelDeleteValuation,
            message: _("confirmationDeleteValuationMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationDeleteCategoryTitle"
          }}
        />
        <TTPDialog
          showDialog={this.state.deleteValuationIsForced}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleDeleteValuation,
            abortAction: this.cancelDeleteForcedValuation,
            message: _("confirmationForcedDeleteCategoryMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationForceDeleteCategoryTitle"
          }}
        />
        <TTPDialog
          showDialog={this.state.updateCategoryIsForced}
          loading={this.state.loading}
          TTPDialog={{
            approvedAction: this.handleUpdateCategory,
            abortAction: this.cancelUpdateForcedCategory,
            message: _("confirmationForcedUpdateCategoryMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("No"),
            type: DIALOG_TYPES.ALERT,
            title: "confirmationForceUpdateCategoryTitle"
          }}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng,
  categories: state.categoriesSettings.items,
  superCategories: state.categoriesSettings.superCategories,
  analysisPlan: state.categoriesSettings.analysisPlan,
  valuations: state.categoriesSettings.valuations,
  modified: state.categoriesSettings.modified,
  fetching: state.categoriesSettings.fetching,
  fetched: state.categoriesSettings.fetched,
  saving: state.categoriesSettings.saving,
  saved: state.categoriesSettings.saved,
  deleting: state.categoriesSettings.deleting,
  deleted: state.categoriesSettings.deleted
});

export default connect(mapStateToProps)(CategorySettingPage);



// WEBPACK FOOTER //
// ./src/components/CategorySettings/CategorySettingsPage.js